import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { EvaluatorRegistryPage } from "@/features/evaluator-operations/registry/evaluator-registry-page";
import {
  EVALUATOR_FAMILY_VALUES,
  EVALUATOR_LIFECYCLE_VALUES,
  EVALUATOR_SORT_VALUES,
  SORT_DIRECTION_VALUES,
} from "@/features/evaluator-operations/types";

export const Route = createFileRoute("/evaluators/")({
  validateSearch: z.object({
    page: z.coerce.number().int().min(1).catch(1),
    limit: z.coerce.number().int().min(1).max(100).catch(10),
    q: z.string().optional(),
    family: z.enum(EVALUATOR_FAMILY_VALUES).optional(),
    lifecycle: z.enum(EVALUATOR_LIFECYCLE_VALUES).optional(),
    sort: z.enum(EVALUATOR_SORT_VALUES).catch("name"),
    direction: z.enum(SORT_DIRECTION_VALUES).catch("asc"),
  }),
  component: () => (
    <PermissionGuard module="evaluators">
      <EvaluatorRegistryPage />
    </PermissionGuard>
  ),
});
